export function getLocalDateKey(date: Date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getInclusiveLocalDayWindowStart(endDate: Date, numberOfDays: number): Date {
  if (!Number.isInteger(numberOfDays) || numberOfDays < 1) {
    throw new RangeError('numberOfDays must be a positive integer');
  }

  const startDate = new Date(endDate);
  startDate.setDate(startDate.getDate() - (numberOfDays - 1));
  startDate.setHours(0, 0, 0, 0);
  return startDate;
}
